import * as PDFJSLib from 'pdfjs-dist/legacy/build/pdf.mjs';

export const SCREEN_PPI = PDFJSLib.PixelsPerInch.CSS;
export const POINT_PPI = PDFJSLib.PixelsPerInch.PDF;
